// Module
var code = "<div class=\"pagination nsan-toggle-fade\" ng-show=\"show\"> <a ng-repeat=\"page in pages track by page.i\" ng-click=\"selectPage($event, page)\" ng-class=\"page.classes\">{{page.text}}</a> </div> ";
// Exports
var _module_exports =code;;
var path = '/codebuild/output/src1812303292/src/frontend/js/directives/public/nsPagination.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;